import {useContext, useEffect, useState, useRef} from 'react';
import FormContext from '../../../context/form-context';
import { setFormSignatories } from "../../../state/action";
import { useToggle } from '../../../hooks/useToggle';
import dayjs from 'dayjs';
import { addSpaceBeforeCapsAndNumbers, createFormData, getExistingFileName } from '../../../utils/utilities';
import { PDFDocument } from 'pdf-lib'
import { setAlert } from "../../../state/action";
import { updateSelectedTemplates, updateSubmittedForm } from '../../../services/firebase/submittedForms/tb_submittedForms';
import { useParams } from 'react-router-dom';
import { ALERT_TYPE } from '../../../constants/alert-type';
import { constructFormData_toPDF, downloadBlobFile } from '../pdfUtil';
import { uploadFile } from '../../../services/real-star-api/file/upload-file';
import { checkIfFileExists } from '../../../services/real-star-api/file/file-checker';

const useSignatoryPage = ( openedFile ) => {
    const { appState , dispatch} = useContext(FormContext);
    const [open, setOpen] = useToggle(false);
    const [selectedFormSignatories , setSelectedFormSignatories] = useState('')
    const [openedSignatory , setOpenedSignatory] = useState('')
    const [ onReset, setOnReset] = useState(false)
    const sigPadRef = useRef()
    const {mainValues} = appState.formState;
    const { agentDetails , formSignatories , userDetails} = appState;
    const { transactionID } = appState.formInfo;
    const [isMounted , setIsMounted] = useState(false)
    const { transID } = useParams();

    useEffect(() => {

        const initializeSignatories = async () => {
            if (formSignatories.length > 0) {
                //with existing
                const currentSignatoryObj = formSignatories.find(form => form.formId === openedFile.Id)
                const newSignatoryObj = await getSignatoriesObj(openedFile)

                //if the selected (form) signatory is not exists
                if (!currentSignatoryObj) {
                    //set New
                    dispatch(setFormSignatories([...appState.formSignatories, newSignatoryObj]))
                } else {
                    //exists
                    //set the updated Value. 
                    //Purpose(if name of has changed, the signatory name should be changed)
                    const newSignatories = newSignatoryObj?.signatoryValues?.map(sign => {
                        const curr = currentSignatoryObj?.signatoryValues?.find(curSig => curSig.field === sign.field);
                        return {
                            ...sign,
                            [sign.field+'Signature']: curr?.signature ?? '',
                            [sign.field+'SignedDate']: curr?.[sign.field+'SignedDate'] ?? '',
                            signature: curr?.signature ?? ''
                        }
                    })
                    //the updated values
                    const updatedSigValues = {
                        ...currentSignatoryObj,
                        signatoryValues: newSignatories
                    }
                    //set new state
                    const filteredSignatories = formSignatories.filter(form => form.formId !== openedFile.Id);
                    dispatch(setFormSignatories([...filteredSignatories, updatedSigValues]))

                }
                setIsMounted(true)

            } else {
                // no existing
                const newSignatoryObj = await getSignatoriesObj(openedFile)
                dispatch(setFormSignatories([...appState.formSignatories, newSignatoryObj]))
                setIsMounted(true)
            }
        }

        initializeSignatories();
    }, [])

    useEffect( () => {
        //the display state
        setSelectedFormSignatories(formSignatories.find( form => form.formId === openedFile.Id))
        setIsMounted(true)
    },[formSignatories])

    const getSignatoriesObj = async (file) => {

        const keyword = "Signature"
        const replacer = "Name"
        
        //get Signatory Fields from PDF Temlate
        const signatoryFields = await getSignatoriesFieldsFromPDF(file, keyword);
        //replace, from Signature to Name (e.g seller1Signature -> seller1Name)
        const signatoriesName = signatoryFields.map(sign => sign.replace(keyword, replacer))
        //get the data from the Form Values
        const signatoriesObj = await getSignatoryValues(mainValues, agentDetails , signatoriesName)

        const formSignatoriesObj = {
            formId: file.Id,
            formName: file.FormName,
            signatoryValues: signatoriesObj
        }
       
        return formSignatoriesObj;
    }

    const getSignatoriesFieldsFromPDF = async (file , keyword) =>{
        const PDF_FILE = getFilePath(file)
         const signatories = []
 
         if (!PDF_FILE) {
             dispatch(setAlert({
                 show: true,
                 title: 'Template Error',
                 body: 'No existing PDF Template.',
             }))
             console.log(`Please check this path ${file.LocalPath}`)
             return;
         }
 
         // Load the PDF document
         const formPdfBytes = await fetch(PDF_FILE).then(res => res.arrayBuffer())
         const pdfDoc = await PDFDocument.load(formPdfBytes);
         //get Form Fields
         const form = pdfDoc.getForm();
         
         const signatoryFieldsInPDF = form.getFields()
         
         if(signatoryFieldsInPDF.length > 0) {
             signatoryFieldsInPDF.forEach( field => {
                 const fieldName = field.getName();
                 //signature
                 if(fieldName?.includes(keyword) && !fieldName?.includes("Date") ) 
                 signatories.push(fieldName)
                 }
             )
         }
         return signatories
     }
 
     const getSignatoryValues =  (mainValues, agentDetails ,signatoriesName) => {
 
         const arrOfSignatories = [];
        const name = "Name"
        const signature = "Signature"
         //form values
         for (let key in mainValues) {
             const varName = signatoriesName.find(keyword =>
                 key?.includes(keyword) && !key.includes("ID")
             );
             
             if (varName) {

                const fieldName =  addSpaceBeforeCapsAndNumbers(key)

                 if (mainValues[key]) {
                     arrOfSignatories.push({
                         fieldName: fieldName,
                         fieldName2: key,
                         field: key.replace(name, ""),
                         name: mainValues[key],
                         signature: '',
                         [key.replace(name,signature)]: '',
                         [key.replace(name,"SignedDate")]: ''
                     })
                 }
             }
         }
         //agent details
         agentDetails.agentName = agentDetails?.display_name
         for (let key in agentDetails) {
            const fieldName =  addSpaceBeforeCapsAndNumbers(key)

            const varName = signatoriesName.some(keyword =>
                key?.includes(keyword)
            );

            if (varName) {
                if (agentDetails[key] || agentDetails?.display_name) {
                    arrOfSignatories.push({
                        fieldName: fieldName,
                        fieldName2: key,
                        field: key.replace(name, ""),
                        name: agentDetails[key],
                        signature: '',
                        [key.replace(name, signature)]: '',
                        [key.replace(name, 'SignedDate')]: ''
                    })
                }
            }
        }
        return arrOfSignatories;
     }

     const getFilePath = (file) => {
        const PUBLIC_FOLDER = process.env.PUBLIC_URL;
        return file.LocalPath ? PUBLIC_FOLDER + file.LocalPath : ""
    }

    const openSigPad = (val) => {
        setOpen(true);
        setOpenedSignatory(val);
    }

    const modalBtnAction = { 
        onClose: () => { 
            setOpen(false)
            setOnReset(false)
        },
        onSubmit: async () => {

            setOnReset(false)

            const name = "Name"
            const signature = "Signature"

            const textSignature = sigPadRef.current?.getTrimmedCanvas().toDataURL('image/png');
            const isEmpty = sigPadRef.current?.isEmpty();

            if (textSignature) {

                // Find the signatories for the currently opened form
                const updatedFormSignatories = formSignatories.find(form => form.formId === openedFile.Id);

                if (updatedFormSignatories) {
                    // Update the signatory values with the new signature and date
                    const newSignatoriesObj = updatedFormSignatories?.signatoryValues?.map(item => {
                        if (item.fieldName === openedSignatory.fieldName) return {
                            ...item,
                            signature: isEmpty ? "" : textSignature,
                            [item.fieldName2.replace(name, signature)]: isEmpty ? "" : textSignature,
                            [item.fieldName2.replace(name, 'SignedDate')]: dayjs(new Date()).format('DD-MMM-YYYY')
                        }
                        else return { ...item }
                    })
                    // Combine updated signatories with the existing ones
                    const newsSignatoriesValue = {
                        ...updatedFormSignatories,
                        signatoryValues: newSignatoriesObj
                    }

                    // Update the formSignatories state
                    const updatedSignatories = formSignatories.map(form =>
                        form.formId === openedFile.Id
                            ? newsSignatoriesValue
                            : form
                    );

                    dispatch(setFormSignatories(updatedSignatories))
                    await updateSignatureInDB(updatedSignatories, openedFile.FormName);

                
                    await reuploadtheCurrentFile(userDetails , openedFile , newsSignatoriesValue , mainValues , agentDetails);
                    
                    //close loading
                    dispatch(setAlert({
                        show: false,
                        title: "",
                        body: ``,
                        showBtn: false
                    }))
            

                }
            }
            setOpen(false)
        }
    }
    
    const signaturePadAction = {
        onClear: () => {
            sigPadRef.current?.clear();
        },
        onReset: () => {
            setOnReset(true)
        },

    }

    const updateSignatureInDB = async (data , formName) => {
        
        dispatch(setAlert({
            show: true,
            title: 'Processing Form Signatories',
            body: `The signature is currently being submitted. <br/> Kindly wait a moment.`,
            showBtn: false
        }))

        const newData = {
            FormSignatories: data,
            ModifiedBy: appState.agentDetails,
        }
        try {
            await updateSubmittedForm(transID, newData);
            await updateSelectedTemplates(transID, formName) //update in Selected Templates
            
        } catch (err) {
            dispatch(setAlert({
                show: true,
                title: ALERT_TYPE.ERROR.toUpperCase(),
                body: "Error on saving the signatories and templates.",
            }))
        }

    } 

    const reconstructSignatories = (signatoryValues) => {
        return signatoryValues?.reduce((acc, item) => {
            acc[item.field + 'Signature'] = item[item.field + 'Signature'];
            acc[item.field + 'SignedDate'] = item[item.field + 'SignedDate'];
            return acc;
        }, {});
    }

    const reuploadtheCurrentFile = async (userDetails , file , formSignatories , mainValues , agentDetails) => {

        //check if file exists:
        //without space // default to .pdf
        const existingFileName = getExistingFileName(file?.FormName)
        const existingFileURL = await checkIfFileExists(transID, existingFileName); //transID  = from URL or parameter 

        //upload the updated document
        const userEncryptedID = userDetails?.encrypted_id

        const newFileName = `${file?.FormName?.replace(/\s+/g, '')}.pdf`;
        const newSignatoryValues = reconstructSignatories(formSignatories.signatoryValues)
       
        //if file exists;
        if(existingFileURL){
            const cacheBustingURL = `${existingFileURL}?t=${new Date().getTime()}`
            const response = await fetch(cacheBustingURL);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            try {
                const templateURL = await response?.url;

                const blob = await constructFormData_toPDF(templateURL,newSignatoryValues, mainValues, agentDetails); //plot the form data
                const formData = createFormData(blob , newFileName, transID) //transID  = from URL or parameter 
          
                dispatch(setAlert({
                    show: true,
                    title: 'Re-Uploading the File',
                    body: `The file are currently re-uploading. <br/><br/>Kindly wait a moment. `,
                    showBtn: false
                }))
                console.log(`existing file reuploading... (${file.FormName})` )
                await uploadFile(formData, userEncryptedID); // Uncomment when ready to upload
                
            } catch (error) {
                console.log(error)
                dispatch(setAlert({
                    show: true,
                    title: ALERT_TYPE.ERROR.toUpperCase(),
                    body: `File Upload Failed. Please try again. <br/><br/> Filename: ${file.FormName}`,
                }))
            }

        }else{
            const PUBLIC_FOLDER = process.env.PUBLIC_URL;
            const templateLocalPath = PUBLIC_FOLDER + file.LocalPath
            
            const blob = await constructFormData_toPDF( templateLocalPath, newSignatoryValues,mainValues,agentDetails );
            const formData = createFormData(blob, newFileName, transactionID)
    
            try {
                dispatch(setAlert({
                    show: true,
                    title: 'Uploading File',
                    body: `The file is currently uploading. <br/><br/>Kindly wait a moment.  `,
                    showBtn: false
                }))

                console.log(`new file uploading... (${file.FormName})` )
                await uploadFile(formData, userEncryptedID);
                
            } catch (err) {
                console.error('Upload error:', err);
                dispatch(setAlert({
                    show: true,
                    title: 'Upload Error',
                    body: `File Upload Failed. Please try again.`,
                }))
            }
        }
        
    }


    

    return {
        sigPadRef,
        openSigPad,
        open,
        openedSignatory,
        modalBtnAction,
        signaturePadAction,
        onReset,
        isMounted,
        selectedFormSignatories
    }

}

export default useSignatoryPage;